import React from "react";
import { Container } from "react-bootstrap";

const Layout = ({ children }) => {
  return <Container fluid className="my-5">{children}</Container>;
};

export default Layout;